<template>
  <div>
    <label>{{ label }}</label>
    <br />
    <v-row>
      <v-col cols="12" lg="6" md="6" sm="12">
        <v-date-picker
          v-model="theDate"
          class="picker"
          full-width
          required
          @input="onDateChanged"
        ></v-date-picker>
      </v-col>
      <v-col cols="12" lg="6" md="6" sm="12">
        <v-time-picker
          v-model="theTime"
          class="picker"
          full-width
          required
          @input="onTimeChanged"
        ></v-time-picker>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'date-time-ctrl',
  props: {
    datetime: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    }
  },

  data: () => ({
    theDateTime: '',
    theDate: null,
    theTime: null
  }),

  created() {
    console.log('DateTime.created()')
    if (this.datetime) {
      this.theDateTime = this.datetime
      this.theDate = this.theDateTime.substring(0, 10)
      this.theTime = this.theDateTime.substring(11, 16)
    }
  },

  methods: {
    onDateChanged() {
      this.update()
    },

    onTimeChanged() {
      this.update()
    },

    update() {
      this.theDateTime = this.theDate + 'T' + this.theTime
      this.$emit('dateChanged', this.theDateTime)
    }
  },

  watch: {
    datetime: function(dt) {
      console.log('DateTime.datetime changed')
      this.datetime = dt
      if (this.datetime) {
        this.theDateTime = this.datetime
        this.theDate = this.theDateTime.substring(0, 10)
        this.theTime = this.theDateTime.substring(11, 16)
      }
    }
  }
}
</script>
